export const TableAlignment = {
    left: 'left',
    center: 'center',
    right: 'right'
} as const

export type TableAlignmentType = typeof TableAlignment[keyof typeof TableAlignment]